<div class="row-direction">
	<input matInput [matAutocomplete]="auto" [mask]="unifiedAccountMask" [showMaskTyped]="props.showMask" [patterns]="props.patterns"
		[dropSpecialCharacters]="to.dropSpecialCharacter" [errorStateMatcher]="errorStateMatcher" [formControl]="inputFormControl"
		[formlyAttributes]="field" (blur)="onBlur()" />
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionChanged($event.option)">
		<ng-container *ngIf="{options: filter | async} as Obj">
			<mat-option *ngIf="Obj.options && Obj.options.length === 0" disabled>No records found</mat-option>
			<mat-option *ngFor="let option of (Obj.options || [])" [value]="option">
				{{ option.AccountNumber }}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
	<mat-icon *ngIf="props.canSearch ?? true" aria-hidden="false" aria-label="Clean" matSuffix (click)="removeAccount()">close</mat-icon>
	<mat-icon *ngIf="props.canSearch ?? true" aria-hidden="false" aria-label="Search" matSuffix (click)="openAccountTable($event)">search</mat-icon>
</div>